module.exports = __webpack_public_path__ + "img/FR10218.b4c75cd0.png";